import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

let interval = false;

export function Header(props) {
    return (
        <div className="logo mb-3">
            <Link to="/">

               <span className="color-primary">AI</span>nvestor

            </Link>
        </div>
    )
}